<template>
	<v-card class="resource-page" style="border-radius: 10px; max-width: 600px" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-card-text>
				<FilterChipButton
					:isButtonActive="isButtonActive"
					:chipsList="chipsList"
					:clearFilter="clearFilter"
					@handleChipClick="handleChipClick"
					:isAdvancedResources="isAdvancedResources"
					@toggleList="toggleList"
					:listView="listView"
				/>
				<div v-if="filterModalIsVisible">
					<FilterModal
						:filterModalIsVisible="filterModalIsVisible"
						:currentModalFilter="currentModalFilter"
						:currentModalLabel="currentModalLabel"
						:selectedChips="selectedChips"
						:filters="filters"
						:dateError="date.error"
						:dateOption="date.option"
						:dateRange="date.selectedRange"
						@closeModal="closeModal"
						@applySelection="applySelection"
						@setItem="setItem"
					/>
				</div>

				<Banner v-if="banner && !isLoading" :banner="banner" :mt="20" />

				<v-skeleton-loader
					style="max-width: 600px"
					v-bind="attrs"
					type="card"
					v-if="this.isLoading"
				/>

				<AdvancedResourceList
					v-if="
						!this.isLoading &&
						this.resourcesItems.length > 0 &&
						isAdvancedResources &&
						!listView
					"
					:resourcesItems="resourcesItems"
				/>

				<ResourceList
					v-if="
						!this.isLoading &&
						this.resourcesItems.length > 0 &&
						(!isAdvancedResources || listView)
					"
					:resourcesItems="resourcesItems"
				/>

				<div
					v-if="!this.isLoading && this.resourcesItems.length === 0"
					class="mt-5 align-center"
				>
					<NewsFeedEmpty
						title="Resources is empty at the moment."
						description="Check back later."
					/>
				</div>

				<div
					class="d-flex my-9 ma-auto justify-center home-page__pagination"
					v-if="!this.isLoading && this.resourcesItems.length > 0"
				>
					<Pagination
						:page="filters.page"
						:pageCount="pageCount"
						@pageChange="onPageChange"
					/>
				</div>
			</v-card-text>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import ResourceList from '@/components/Resource/ResourceList.vue'
import AdvancedResourceList from '../components/Resource/AdvancedResourceList.vue'
import Block from '@/mixins/Block.js'
import PageBlocked from '@/components/PageBlocked'
import Pagination from '@/components/Pagination.vue'
import _ from 'lodash'
import FilterChipButton from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal'
import Filter from '@/mixins/Filter'
import Banner from '@/components/Banner'

export default {
	name: 'ResourcePage',
	mixins: [Block, Filter],
	components: {
		FilterChipButton,
		ResourceList,
		NewsFeedEmpty,
		AdvancedResourceList,
		PageBlocked,
		Pagination,
		FilterModal,
		Banner,
	},
	computed: {
		...mapGetters('resources', [
			'resourcesList',
			'isLoading',
			'singleMeta',
			'breadCrumbs',
			'listView',
		]),
		...mapGetters('advertisement', ['banner']),

		resourcesItems() {
			return this.resourcesList || []
		},
		pageCount() {
			if (!this.singleMeta) {
				return 0
			}

			return +this.singleMeta.pageCount
		},
		isAdvancedResources() {
			return parseInt(this.$route.query.advance, 10) === 1
		},
		folderTitle() {
			return this.$route.query.title || null
		},
	},
	methods: {
		...mapActions('resources', [
			'getResourcesById',
			'clearResources',
			'toggleListView',
			'getResourcesById',
		]),
		...mapActions('advertisement', ['getBanner', 'clearBanner']),
		...mapActions('app', ['setPageTitle']),

		toggleList() {
			this.toggleListView()
		},
	},
	watch: {
		'$route.params.id': {
			handler(newValue, oldValue) {
				if (newValue !== oldValue) {
					this.clearBanner()
					this.clearResources()

					const bannerQuery = {
						places: ['resource_folders'],
						place_sub_id: newValue,
						page: this.filters.page,
					}
					if (this.selectedChips.chapters && this.selectedChips.chapters.length) {
						bannerQuery.chapter_id = this.selectedChips.chapters
					}
					this.getBanner(bannerQuery)

					this.getResourcesById(this.requestQuery)
				}
			},
		},
	},
	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			pageBlockedName: 'resources',
		}
	},
	mounted() {
		this.setPageTitle(this.folderTitle)
	},
	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.getResourcesById(this.requestQuery)
			const bannerQuery = {
				places: ['resource_folders'],
				place_sub_id: this.$route.params.id,
				page: this.filters.page,
			}
			if (this.selectedChips.chapters && this.selectedChips.chapters.length) {
				bannerQuery.chapter_id = this.selectedChips.chapters
			}
			this.getBanner(bannerQuery)
		}
	},
	beforeDestroy() {
		this.setPageTitle('')
		this.clearResources()
		this.clearBanner()
	},
}
</script>

<style lang="scss">
.resource-page {
	max-width: 600px;
	width: 100%;
	border-radius: 10px !important;
	margin-bottom: 30px;
	background-color: transparent !important;

	@media (max-width: 480px) {
		margin-bottom: 12px;
	}

	&__page-title {
		font-size: 24px;
		font-weight: 700;
		font-family: Montserrat, sans-serif;
		color: #4a4a4a;
		line-height: 29px;
		margin: 0 !important;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		word-break: break-word;
	}

	&__title {
		font-style: normal;
		cursor: pointer;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}
}

.navigate-back {
	&__icon {
		color: var(--accent-color);
	}

	&__text {
		color: var(--accent-color);
		font-size: 15px;
		font-weight: 700;
		line-height: 18px;
		text-decoration: underline;
	}
}

.cursor-pointer {
	cursor: pointer;
}

@media screen and (max-width: 960px) {
	.resource-page__title {
		font-size: 25px !important;
	}
}
</style>
